import {fetchConToken} from '../helpers/fetch'

const getAllExternalsPag = async (currentPage: any, numberData: any, options: any) => {
  const queryString = new URLSearchParams(options).toString()

  const resp = await fetchConToken(
    `external/${currentPage}/${numberData}?${queryString}`,
    {},
    'GET'
  )

  const body = await resp.json()

  return body
}

const crearExternalData = async (data: any) => {
  const resp = await fetchConToken(`external/add`, data, 'POST')
  const body = await resp.json()

  return body
}

const addFieldExternalData = async (id: string, data: any) => {
  const resp = await fetchConToken(`external/add/field/${id}`, data, 'POST')
  const body = await resp.json()

  return body
}

const updateExternalData = async (id: string, updatedData: any) => {
  const resp = await fetchConToken(`external/${id}`, updatedData, 'PUT')
  const body = await resp.json()

  return body
}

const getExternals = async (options: any) => {
  const queryString = new URLSearchParams(options).toString()
  const resp = await fetchConToken(`external?${queryString}`, {}, 'GET')
  const body = await resp.json()

  return body
}

const createCustomExternal = async () => {
  const resp = await fetchConToken('external/create/custom', {}, 'POST')
  const body = await resp.json()

  return body
}

const getActualizarGroupField = async (id: string) => {
  const resp = await fetchConToken(`external/actualizar/groupfields/${id}`, {}, 'GET')
  const body = await resp.json()

  return body
}

const getExternalById = async (id: string) => {
  const resp = await fetchConToken(`external/get/findById/${id}`, {}, 'GET')
  const body = await resp.json()

  return body
}

const deleteExternal = async (id: string) => {
  const resp = await fetchConToken(`external/${id}`, {}, 'DELETE')

  const body = await resp.json()
  return body
}

const activarExternal = async (id: string) => {
  const resp = await fetchConToken(`external/activar/${id}`, {}, 'PUT')

  const body = await resp.json()
  return body
}

const addToExternalCustom = async (id: string, data: any) => {
  const resp = await fetchConToken(`external/add/custom/${id}`, data, 'POST')
  const body = await resp.json()
  return body
}

const deleteCustomFromEntity = async (id: string) => {
  const resp = await fetchConToken('external/delete/custom', {identifier: id}, 'POST')
  const body = await resp.json()
  return body
}

export {
  activarExternal,
  addFieldExternalData,
  addToExternalCustom,
  crearExternalData,
  deleteCustomFromEntity,
  deleteExternal,
  getActualizarGroupField,
  getAllExternalsPag,
  getExternalById,
  getExternals,
  updateExternalData,
  createCustomExternal,
}
